import './website-styles.scss';
import * as EmailValidator from 'email-validator';

// @ts-expect-error: no ts types
window.EmailValidator = EmailValidator;
